var cssInstalledChunks = {};
var cssLoadingUniqueName = "fluxer_app";
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = function(chunkId, url, done, hmr, fetchPriority) {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");

if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}


link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;



	}
	var onLinkComplete = function(prev, event) {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = function(chunkId, promises, fetchPriority) {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(node_modules_pnpm_(arborium_arborium_2_18_2_node_modules_arborium_arborium_dist_themes_github\-\-(204bdc|526ce0)|katex_0_19_1_node_modules_katex_dist_katex_min_css)|src_(app_(BootstrapErrorMount_tsx|SetupHttp_ts)|features_(p(remium_components_(operator_pass_OperatorPass(OfferModal|RoutePage)_tsx|p(ages_PremiumCallbackPage|lutonium_page_PlutoniumPageLayout)_tsx)|ermissions_system_components_modals_MacPermissionsModal_tsx)|in(vite_components_pages_Invite(Login|Register)Page_tsx|put_components_modals_KeyboardModeIntroModal_tsx)|a(pp_(components_(floating_ColorPickerPopover|pages_YouPage)_tsx|keybindings_KeybindManager_ts)|uth_(components_(pages_(AuthorizeIP|EmailRevert|Login|ResetPassword|VerifyEmail)Page_tsx|(NetworkBlockedHandler|accounts_AccountSwitcherModal)_tsx)|flow_AuthFirstScreen_ts|passkey_migration_PasskeyMigration_ts\-src_features_auth_passkey_migration_P\-15534a|state_NewDeviceMonitoring_tsx))|c(hannel_components_(modals_(BookmarksBottomSheet|ChannelSettingsModal)_tsx|GuildMembersPage_tsx)|ode_highlighting_utils_ArboriumThemeBridge_css|onnection_components_pages_ConnectionCallbackPage_tsx)|search_components_(bottomsheets_QuickSwitcherBottomSheet|quick_switcher_QuickSwitcherModal)_tsx|u(ser_(components_modals_(UserSettingsModal_tsx\-_abd8[01]|StatusChangeBottomSheet_tsx)|state_Users_ts\-_174a[012])|pdater_commands_UpdaterModalCommands_tsx)|voice_(components_bottomsheets_VoiceLobbyBottomSheet_tsx|diagnostics_VoiceSubscriptionDebugReport_ts)|expressions_components_pages_Gift(Login|Register)Page_tsx|theme_(fonts_ScriptFaces(JP|KR|NonLatin|SC|TC)_ts|components_pages_Theme(Login|Register)Page_tsx|settings_components_QuickCssWorkspace_tsx)|((moderation_components_pages_Report|notification_components_pages_Notifications)Page|guild_components_modals_GuildSettingsModal)_tsx))|app\-bootstrap|boot\-app|main)$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
